module.exports = __webpack_public_path__ + "img/ic_check_layer1.1195e751.png";